module.exports = __webpack_public_path__ + "img/learn-left-hand.ec83703e.png";